import { createEffect, createEvent, Store } from 'effector';
import { IProfile, IUser } from '@src/models/auth';
import { getAccountDataFromUser, isPartialEqual } from './utils';
import type { NgApiClient } from '@src/api/ngApiClient';
import { AccountClientManager } from '@src/utils/accountClient';
import { $profileStore as globalProfileStore, $userStore as globalUserStore } from '@centra/ui-global-context';

/** Пользователь из куки */
const $userStore = globalUserStore as Store<IUser | null>;

/** Профиль пользователя с аватаром и именем */
const $profileStore = globalProfileStore as Store<IProfile | null>;

const setUser = createEvent<IUser | null>();
const updateUser = createEvent<Partial<IUser>>();

const updateProfile = createEvent<Partial<IProfile>>();
const fetchProfileFx = createEffect(async ({ ngApiClient }: { ngApiClient: NgApiClient }) => {
  return (await ngApiClient.restClient.get('/account/me').then((res) => res?.data)) as IProfile;
});

$userStore
  .on(setUser, (_, newUser) => newUser)
  .on(updateUser, (user, update) => {
    if (!user || isPartialEqual(update, user)) return user;
    return { ...user, ...update };
  });

$profileStore
  .on(updateProfile, (profile, update) => {
    if (!profile || isPartialEqual(update, profile)) return profile;
    return { ...profile, ...update };
  })
  /** Сохраняем пользователя при успешном получении */
  .on(fetchProfileFx.doneData, (_, newProfile) => {
    /**
     * Обновляем данные текущего аккаунта, которые будем использовать при разлогине
     * А также обновляем прилинкованных пользовтелей
     */
    const updateAccountList = [getAccountDataFromUser(newProfile, { active: true })];

    if (newProfile.linkedUsers) {
      newProfile.linkedUsers.forEach((u) => {
        updateAccountList.push(getAccountDataFromUser(u, { active: false }));
      });
    }

    AccountClientManager.updateAccounts(updateAccountList);

    return newProfile;
  });

export const userEffectorModel = {
  $userStore,
  $profileStore,
  updateProfile,
  setUser,
  updateUser,
  fetchProfileFx,
};
